import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form'

import { connect } from 'react-redux';

import { Actions as PAYMENTACTIONS } from '../../../store/actions/paymentActions';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { format } from 'date-fns';
import CheckoutForm from '../../billing/CheckoutForm';
import {
	useStripe,

} from '@stripe/react-stripe-js';

import Select, { components } from 'react-select';
import { DocumentArrowDownIcon } from '@/icons/outline';
import { LockClosedIcon, PlusCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import Spinner from "../Spinner";
import { stripePromise } from "../../../store/actions/apiURL";
import buddyFace from '../../../images/buddy-face.png';

const { Option } = components;


// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.


const IconOption = props => (
	<Option {...props}>
		<i className={`fab fa-cc-${props.data.brand}`} style={{ marginRight: 10 }} />
		{props.data.label}
	</Option>
);

const customSingleValue = ({ data }) => (
	<div className="input-select">
		<div className="input-select__single-value">
			<i className={`fab fa-cc-${data.brand}`} style={{ marginRight: 10 }} />
			{data.label}
		</div>
	</div>
);

const PaymentMethods = ({
	paymentOptions,
	businessDetails,
	advisorCharge,
	vatRate,
	selectedBundle,
	stripePaymentMethods,
	getStripePaymentMethods,
	createStripeCharge,
	clearBundle,
	currency,
	addNewCard,
	setAddNewCard,
	paymentIntent,
	processStripeCharge,
	processingStripeCharge,
	invoiceNo,
	creditId,
	downloadInvoice,
	closeModal
}) => {


	// const stripe = useStripe();

	const on3DSComplete = async (intent, secret) => {
		// Check the PaymentIntent

		// should normally not wait as it would have already resolved
		const stripe = await stripePromise;

		stripe.retrievePaymentIntent(secret)
			.then(function (result) {
				console.log('result.paymentIntent', result.paymentIntent)

				if (result.error) {
					// PaymentIntent client secret was invalid
				} else {
					if (result.paymentIntent.status === 'succeeded') {
						// Show your customer that the payment has succeeded

						// send redux action to save intent as succeeded
						processStripeCharge(intent)

					} else if (result.paymentIntent.status === 'requires_payment_method') {
						// Authentication failed, prompt the customer to enter another payment method
					}
				}
			});
	}

	const [selectedCard, setSelectedCard] = useState(paymentOptions && paymentOptions[0])

	// const [sidebarOpen, setSidebarOpen] = useState(false)
	useEffect(() => {
		getStripePaymentMethods(advisorCharge)

		window.addEventListener('message', function (ev) {
			if (ev.data["3DS"] == true) {
				on3DSComplete(ev.data.intent, ev.data.secret);
			}
		}, false);

	}, []);

	useEffect(() => {
		if (stripePaymentMethods && stripePaymentMethods.length == 0 && !addNewCard) {
			setAddNewCard(true)
		}
	}, [
		stripePaymentMethods && stripePaymentMethods.length,
		addNewCard
	]);


	useEffect(() => {
		if (paymentOptions && paymentOptions.length > 0) {
			setSelectedCard(paymentOptions[0])
		}
	}, [
		paymentOptions && paymentOptions.length,
	]);

	if (paymentIntent && paymentIntent.status == "requires_action") {
		return (
			<div
				style={{
					background: "white",
					margin: "auto",
					minWidth: 600,
					maxWidth: 600,
					width: 600,
					padding: "0",
					top: "50%",
					left: "50%",
					width: "100%",
					transform: "translateY(-50%) TranslateX(-50%)",
					position: "absolute",
				}}>
				<iframe
					src={paymentIntent.next_action.redirect_to_url.url}
					width={600}
					height={400}
				/>
			</div>
		)
	}

	if (invoiceNo) {
		return (
			<div
				style={{
					background: "white",
					margin: "auto",
					maxWidth: "450px",
					width: "90%",
					padding: "80px 40px 40px",
					top: "50%",
					left: "50%",
					width: "100%",
					transform: "translateY(-50%) TranslateX(-50%)",
					position: "absolute",
				}}>

				<div style={{
					background: "#ea611c",
					color: "white",
					fontWeight: "bold",
					padding: "15px 40px",
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					textTransform: "uppercase"
				}}>
					<img
						src={buddyFace}
						style={{
							width: 30,
							marginRight: 10,
						}}
					/>
					THANK YOU FOR YOUR PURCHASE

					<div
						style={{
							color: "white",
							position: "absolute",
							top: 15,
							right: 15,
							lineHeight: 1,
							cursor: "pointer",
						}}
						onClick={closeModal}>
						<XMarkIcon className="h-6 w-6 mr-3 text-white" />
					</div>
				</div>


				<div className="btn btn-primary pull-right"
					onClick={() => downloadInvoice(creditId)}
					style={{
						padding: "6px 20px"
					}}>
					<DocumentArrowDownIcon className="h-6 w-6 mr-3" style={{ verticalAlign: "middle" }} />
					DOWNLOAD {invoiceNo}
				</div>

			</div>
		)
	}

	return (
		<div
			style={{
				background: "white",
				margin: "auto",
				maxWidth: "450px",
				width: "90%",
				padding: "80px 40px 40px",
				top: "50%",
				left: "50%",
				width: "100%",
				transform: "translateY(-50%) TranslateX(-50%)",
				position: "absolute",
			}}>

			<div style={{
				background: "#ea611c",
				color: "white",
				fontWeight: "bold",
				padding: "15px 40px",
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				textTransform: "uppercase"
			}}>
				<img
					src={buddyFace}
					style={{
						width: 30,
						marginRight: 10,
					}}
				/>
				PURCHASE {
					selectedBundle.payAsYouGo ?
						`${selectedBundle.credits} Credits` :
						selectedBundle.name
				}
			</div>

			{/*<div style={{
			  display: "grid",
			  gridTemplateColumns: "auto 100px",
			  gridGap: 10,
			  marginBottom: 15,
	        }}>
	        	<div>{selectedBundle.name}</div>
	        	<div>{currency} {selectedBundle.price}</div>
	        </div>*/}

			{/*<h5>Your {selectedBundle.name} Purchase also includes</h5>

			<ul style={{ paddingLeft: 20, marginTop: 10, marginBottom: 20 }}>
				{
					selectedBundle.bonusCredits && selectedBundle.bonusCredits > 0 ?
						<li>
							<PlusCircleIcon style={{ float: "left", height: "1.5em", marginRight: 5 }} />
							{selectedBundle.bonusCredits} Bonus Credits
						</li>
						: <li>
							<PlusCircleIcon style={{ float: "left", height: "1.5em", marginRight: 5 }} />
							{selectedBundle.bonusCredits} Bonus Credits
						</li>
				}
				{
					!selectedBundle.payAsYouGo && false &&
					<li>
						<PlusCircleIcon style={{ float: "left", height: "1.5em", marginRight: 5 }} />
						1 Seat for an online training course
					</li>
				}
			</ul>
			*/}
			{
				!addNewCard && paymentOptions &&
				<div>
					<Select
						options={paymentOptions}
						value={selectedCard}
						onChange={setSelectedCard}
						components={{
							Option: IconOption,
							SingleValue: customSingleValue
						}}
					/>

					<div
						style={{
							cursor: "pointer",
							padding: 5,
							color: "#666",
						}}
						onClick={() => setAddNewCard(true)}>
						+ Add another Card
					</div>

					<div style={{
						display: "grid",
						gridTemplateColumns: "auto 100px",
						gridGap: 10,
						padding: 20,
						color: "#666",
						textAlign: "right",
					}}>
						<div>
							Subtotal
						</div>
						<div>
							{currency} {selectedBundle.price}
						</div>
						<div>
							VAT
						</div>
						<div>
							{currency} {(selectedBundle.price * (vatRate - 1)).toFixed(2)}
						</div>
					</div>

					<div>
						<a className="pull-left"
							onClick={() => clearBundle()}
							style={{
								padding: "6px 0",
								color: "#999",
								cursor: "pointer",
								border: "1px solid transparent"
							}}>
							Cancel
						</a>

						<a className="btn btn-primary pull-right"
							onClick={() => {
								if (!processingStripeCharge)
									createStripeCharge(selectedCard.value,advisorCharge)
							}}
							style={{
								padding: "6px 20px"
							}}>
							{processingStripeCharge ?
								<Spinner
									style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
									className="animate-spin -ml-1 mr-3 h-5 w-5 "
								/>
								:
								<LockClosedIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
							}
							<div style={{float: "left"}}>PAY {currency} {(selectedBundle.price * vatRate).toFixed(2)}</div>
						</a>
					</div>
				</div>
			}

			{addNewCard &&
				<Elements stripe={stripePromise}>
					<CheckoutForm />
				</Elements>
			}
		</div>
	)
}

const mapStateToProps = (state) => {
	console.log('state', state && state.business)

	const paymentOptions = state.payment.stripe && state.payment.stripe.paymentMethods && state.payment.stripe.paymentMethods.map(item => ({
		value: item.id,
		label: `•••• •••• •••• ${item.card.last4} - ${item.card.exp_month}/${item.card.exp_year}`,
		brand: item.card.brand,
	}))

	const currency = state.company?.settings?.currency;

	return {
		paymentOptions,
		businessDetails: state.payment?.stats?.businessDetails,
		addNewCard: state.payment.stripe && state.payment.stripe.addNewCard,
		selectedBundle: state.payment.selectedBundle,
		stripePaymentMethods: state.payment.stripe && state.payment.stripe.paymentMethods,
		processingStripeCharge: state.payment.stripe && state.payment.stripe.processingCharge,
		paymentIntent: state.payment.stripe && state.payment.stripe.paymentIntent,
		invoiceNo: state.payment.stripe && state.payment.invoiceNo,
		creditId: state.payment.stripe && state.payment.creditId,
		currency,
		// malta and UK VAT rates
		vatRate: currency == "€" ? 1.18 : 1.2,
	}
}


const mapDispatchToProps = dispatch => ({
	downloadInvoice: (creditId) => dispatch(PAYMENTACTIONS.downloadInvoice(creditId)),
	processStripeCharge: (intentID) => dispatch(PAYMENTACTIONS.processStripeCharge(intentID)),
	createStripeCharge: (paymentMethodID,advisorCharge) => dispatch(PAYMENTACTIONS.createStripeCharge(paymentMethodID,advisorCharge)),
	getStripePaymentMethods: (advisorCharge) => dispatch(PAYMENTACTIONS.getStripePaymentMethods(null,advisorCharge)),
	clearBundle: () => dispatch(PAYMENTACTIONS.selectBundle(null)),
	setAddNewCard: (status) => dispatch(PAYMENTACTIONS.addNewCard(status)),
	closeModal: () => dispatch(PAYMENTACTIONS.showPricingModal(false)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PaymentMethods) 
